const protocolsList = ['http', 'https'];
const protocolRegex = /^([a-z0-9-]+):\/\//;
const domainRegex = /^(www)\./;
const wildCardPrefix = /^\*\./;

export const normalizeDomain = (domain: string): string => {
  const lowerCasedDomain = domain.toLowerCase();
  const protocolMatch = lowerCasedDomain.match(protocolRegex);
  const hasHttpProtocol = protocolMatch && !protocolsList.includes(protocolMatch[1]);

  if (hasHttpProtocol) {
    return '';
  }

  return lowerCasedDomain
    .replace(wildCardPrefix, '')
    .replace(protocolRegex, '')
    .replace(wildCardPrefix, '')
    .replace(domainRegex, '')
    .replace(wildCardPrefix, '');
};
